import { render, staticRenderFns } from "./SaveReportWizardSubmissionDate.vue?vue&type=template&id=381baab2"
import script from "./SaveReportWizardSubmissionDate.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardSubmissionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports